export const IRIS_PAGE_LOAD_REQUEST = 'IRIS_PAGE_LOAD_REQUEST';
export const IRIS_PAGE_LOAD_SUCCESS = 'IRIS_PAGE_LOAD_SUCCESS';
export const IRIS_PAGE_LOAD_ERROR = 'IRIS_PAGE_LOAD_ERROR';
export const IRIS_PAGE_SET_CACHE = 'IRIS_PAGE_SET_CACHE';
export const IRIS_LOAD_ERROR_PAGE = 'IRIS_LOAD_ERROR_PAGE';
